<div
  class="booking-apartment-panel bg-surface-modal rounded-3xl p-6 sm:p-8 w-full max-w-2xl my-8 shadow-modal relative max-h-[90vh] overflow-y-auto border border-border-strong scrollbar-thin"
  [dir]="'dir' | translate">

  <div class="flex items-center justify-between mb-8 pb-4 border-b border-gray-100">
    <div class="flex items-center gap-3.5">
      <div
        class="w-11 h-11 flex items-center justify-center rounded-2xl bg-primary-soft text-primary border border-primary/20">
        <i class="fa-solid fa-calendar-check text-xl"></i>
      </div>
      <div>
        <h2 class="text-gray-900 text-xl font-bold tracking-tight">{{ 'bookingForm.title' | translate }}</h2>
        <p class="text-xs text-gray-400 mt-0.5">{{ 'bookingForm.subtitle' | translate }}</p>
      </div>
    </div>

    <button type="button" (click)="onClose()"
      class="w-9 h-9 flex items-center justify-center bg-gray-50 text-gray-400 rounded-xl hover:bg-red-50 hover:text-red-500 transition-all duration-200 group">
      <i class="fa-solid fa-xmark text-base transition-transform group-hover:rotate-90"></i>
    </button>
  </div>

  <form class="space-y-6" (submit)="onSubmit($event)">

    <div class="space-y-4">
      <h3 class="text-xs font-semibold text-gray-400 uppercase tracking-wider">{{ 'bookingForm.personalInfo' | translate
        }}</h3>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label class="text-gray-700 text-xs font-medium mb-1.5 block">{{ 'bookingForm.name' | translate }}</label>
          <div class="relative group">
            <i
              class="fa-solid fa-user absolute start-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-[#de5806] transition-colors"></i>
            <input type="text" [(ngModel)]="name" name="name" [placeholder]="'bookingForm.namePlaceholder' | translate"
              class="w-full ps-11 pe-4 py-3 bg-gray-50/50 border border-gray-200 rounded-xl focus:outline-none focus:border-[#de5806] focus:bg-white focus:ring-4 focus:ring-orange-50 transition-all duration-200 text-sm text-gray-800"
              required />
          </div>
        </div>

        <div>
          <label class="text-gray-700 text-xs font-medium mb-1.5 block">{{ 'bookingForm.phone' | translate }}</label>
          <div class="relative group">
            <i
              class="fa-solid fa-phone absolute start-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-[#de5806] transition-colors"></i>
            <input type="tel" [(ngModel)]="mobileNumber" name="mobileNumber"
              [placeholder]="'bookingForm.phonePlaceholder' | translate"
              class="w-full ps-11 pe-4 py-3 bg-gray-50/50 border border-gray-200 rounded-xl focus:outline-none focus:border-[#de5806] focus:bg-white focus:ring-4 focus:ring-orange-50 transition-all duration-200 text-sm text-gray-800"
              [class.border-red-400]="mobileNumberInvalid" pattern="^(010|011|012|015)[0-9]{8}$" maxlength="11"
              #phoneInput="ngModel" (input)="validateMobileNumber()" required />
          </div>
          @if (mobileNumberInvalid) {
          <p class="text-red-500 text-xs mt-1 ps-1">{{ 'bookingForm.phoneValidationError' | translate }}</p>
          }
        </div>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label class="text-gray-700 text-xs font-medium mb-1.5 block">{{ 'bookingForm.email' | translate }}</label>
          <div class="relative group">
            <i
              class="fa-solid fa-envelope absolute start-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-[#de5806] transition-colors"></i>
            <input type="email" [(ngModel)]="email" name="email"
              [placeholder]="'bookingForm.emailPlaceholder' | translate"
              class="w-full ps-11 pe-4 py-3 bg-gray-50/50 border border-gray-200 rounded-xl focus:outline-none focus:border-[#de5806] focus:bg-white focus:ring-4 focus:ring-orange-50 transition-all duration-200 text-sm text-gray-800"
              required />
          </div>
        </div>

        <div>
          <label class="text-gray-700 text-xs font-medium mb-1.5 block">{{ 'bookingForm.guestsCount' | translate
            }}</label>
          <div class="relative group">
            <i
              class="fa-solid fa-users absolute start-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-[#de5806] transition-colors"></i>
            <select [(ngModel)]="numberOfGuests" name="numberOfGuests"
              class="w-full ps-11 pe-4 py-3 bg-gray-50/50 border border-gray-200 rounded-xl focus:outline-none focus:border-[#de5806] focus:bg-white focus:ring-4 focus:ring-orange-50 transition-all duration-200 text-sm text-gray-800 appearance-none cursor-pointer">
              @for (guest of guestOptions; track guest) {
              <option [value]="guest">{{ guest }} {{ guest === 1 ? ('bookingForm.guest' | translate) :
                ('bookingForm.guestsPlural' | translate) }}</option>
              }
            </select>
            <i
              class="fa-solid fa-chevron-down absolute end-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none text-xs"></i>
          </div>
        </div>
      </div>
    </div>

    <hr class="border-gray-100" />

    <div class="space-y-4">
      <h3 class="text-xs font-semibold text-gray-400 uppercase tracking-wider">{{ 'bookingForm.bookingPaymentDetails' |
        translate }}</h3>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label class="text-gray-700 text-xs font-medium mb-1.5 block">{{ 'bookingForm.checkIn' | translate }}</label>
          <div class="relative group">
            <i
              class="fa-solid fa-calendar-day absolute start-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-[#de5806] transition-colors"></i>
            <input type="date" [(ngModel)]="checkInDate" name="checkInDate" [disabled]="isDateDisabled"
              class="w-full ps-11 pe-4 py-3 bg-gray-50/50 border border-gray-200 rounded-xl focus:outline-none focus:border-[#de5806] focus:bg-white focus:ring-4 focus:ring-orange-50 transition-all duration-200 text-sm text-gray-800 disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed"
              required />
          </div>
        </div>

        <div>
          <label class="text-gray-700 text-xs font-medium mb-1.5 block">{{ 'bookingForm.checkOut' | translate }}</label>
          <div class="relative group">
            <i
              class="fa-solid fa-calendar-xmark absolute start-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-[#de5806] transition-colors"></i>
            <input type="date" [(ngModel)]="checkOutDate" name="checkOutDate" [disabled]="isDateDisabled"
              class="w-full ps-11 pe-4 py-3 bg-gray-50/50 border border-gray-200 rounded-xl focus:outline-none focus:border-[#de5806] focus:bg-white focus:ring-4 focus:ring-orange-50 transition-all duration-200 text-sm text-gray-800 disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed"
              required />
          </div>
        </div>
      </div>

      @if (isDateDisabled) {
      <div class="alert alert-warning rounded-xl p-3 flex items-start gap-2.5">
        <i class="fa-solid fa-info-circle text-amber-600 mt-0.5 text-sm"></i>
        <p class="text-xs text-amber-800 leading-relaxed">{{ 'bookingForm.datesPreselected' | translate }}</p>
      </div>
      }

      <!-- <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label class="text-gray-700 text-xs font-medium mb-1.5 block">{{ 'bookingForm.rentalDuration' | translate }}</label>
          <div class="relative group">
            <i
              class="fa-solid fa-clock absolute start-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-[#de5806] transition-colors"></i>
            <select [(ngModel)]="rentalType" name="rentalType"
              class="w-full ps-11 pe-4 py-3 bg-gray-50/50 border border-gray-200 rounded-xl focus:outline-none focus:border-[#de5806] focus:bg-white focus:ring-4 focus:ring-orange-50 transition-all duration-200 text-sm text-gray-800 appearance-none cursor-pointer">
              <option value="daily">{{ 'bookingForm.daily' | translate }}</option>
              <option value="weekly">{{ 'bookingForm.weekly' | translate }}</option>
              <option value="monthly">{{ 'bookingForm.monthly' | translate }}</option>
              <option value="yearly">{{ 'bookingForm.yearly' | translate }}</option>
            </select>
            <i
              class="fa-solid fa-chevron-down absolute end-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none text-xs"></i>
          </div>
        </div>

        <div>
          <label class="text-gray-700 text-xs font-medium mb-1.5 block">{{ 'bookingForm.paymentMethod' | translate }}</label>
          <div class="relative">
            <i class="fa-solid fa-credit-card absolute start-4 top-1/2 -translate-y-1/2 text-gray-400"></i>
            <select [(ngModel)]="paymentMethod" name="paymentMethod" disabled
              class="w-full ps-11 pe-4 py-3 border border-gray-200 rounded-xl bg-gray-50 text-gray-500 cursor-not-allowed text-sm appearance-none">
              <option value="misr_card">{{ 'bookingForm.misrCard' | translate }}</option>
            </select>
            <i class="fa-solid fa-lock absolute end-4 top-1/2 -translate-y-1/2 text-gray-400 text-xs"></i>
          </div>
        </div>
      </div> -->
    </div>

    <hr class="border-gray-100" />

    <div class="space-y-4">
      <h3 class="text-xs font-semibold text-gray-400 uppercase tracking-wider">{{ 'bookingForm.locationPricing' |
        translate }}</h3>

      <div class="grid grid-cols-1 sm:grid-cols-4 gap-4">
        <div class="sm:col-span-1">
          <label class="text-gray-700 text-xs font-medium mb-1.5 block">{{ 'bookingForm.currency' | translate }}</label>
          <div class="relative">
            <i class="fa-solid fa-money-bill-wave absolute start-4 top-1/2 -translate-y-1/2 text-gray-400"></i>
            <select [(ngModel)]="currency" name="currency" disabled
              class="w-full ps-11 pe-4 py-3 border border-gray-200 rounded-xl bg-gray-50 text-gray-500 cursor-not-allowed text-sm appearance-none">
              <option value="EGP">{{ 'bookingForm.egp' | translate }}</option>
            </select>
            <i class="fa-solid fa-lock absolute end-4 top-1/2 -translate-y-1/2 text-gray-400 text-xs"></i>
          </div>
        </div>

        <div class="sm:col-span-1">
          <label class="text-gray-700 text-xs font-medium mb-1.5 block">{{ 'bookingForm.city' | translate }}</label>
          <div class="relative group">
            <input type="text" [(ngModel)]="city" name="city" [placeholder]="'bookingForm.cairo' | translate"
              class="w-full px-4 py-3 bg-gray-50/50 border border-gray-200 rounded-xl focus:outline-none focus:border-[#de5806] focus:bg-white focus:ring-4 focus:ring-orange-50 transition-all duration-200 text-sm text-gray-800"
              required />
          </div>
        </div>

        <div class="sm:col-span-1">
          <label class="text-gray-700 text-xs font-medium mb-1.5 block">{{ 'bookingForm.state' | translate }}</label>
          <div class="relative group">
            <input type="text" [(ngModel)]="state" name="state" [placeholder]="'bookingForm.giza' | translate"
              class="w-full px-4 py-3 bg-gray-50/50 border border-gray-200 rounded-xl focus:outline-none focus:border-[#de5806] focus:bg-white focus:ring-4 focus:ring-orange-50 transition-all duration-200 text-sm text-gray-800"
              required />
          </div>
        </div>

        <div class="sm:col-span-1">
          <label class="text-gray-700 text-xs font-medium mb-1.5 block">{{ 'bookingForm.country' | translate }}</label>
          <div class="relative group">
            <input type="text" [(ngModel)]="country" name="country" [placeholder]="'bookingForm.egypt' | translate"
              class="w-full px-4 py-3 bg-gray-50/50 border border-gray-200 rounded-xl focus:outline-none focus:border-[#de5806] focus:bg-white focus:ring-4 focus:ring-orange-50 transition-all duration-200 text-sm text-gray-800"
              required />
          </div>
        </div>
      </div>
    </div>

    <div>
      <label class="text-gray-700 text-xs font-medium mb-1.5 block">{{ 'bookingForm.additionalMessage' | translate
        }}</label>
      <textarea [(ngModel)]="message" name="message"
        class="w-full p-4 bg-gray-50/50 border border-gray-200 rounded-xl focus:outline-none focus:border-[#de5806] focus:bg-white focus:ring-4 focus:ring-orange-50 transition-all duration-200 text-sm text-gray-800 resize-none"
        rows="3" [placeholder]="'bookingForm.messagePlaceholder' | translate"></textarea>
    </div>

    @if (submitError) {
    <div class="alert alert-danger rounded-xl p-3.5 flex items-center gap-2.5">
      <i class="fa-solid fa-circle-exclamation text-lg text-red-500"></i>
      <p class="text-xs font-medium">{{ submitError }}</p>
    </div>
    }

    @if (submitSuccess) {
    <div class="alert alert-success rounded-xl p-3.5 flex items-center gap-2.5">
      <i class="fa-solid fa-circle-check text-lg text-emerald-500"></i>
      <p class="text-xs font-medium">{{ submitSuccess }}</p>
    </div>
    }

    <button type="submit" [disabled]="isSubmitting"
      class="w-full py-3.5 bg-gray-900 hover:bg-[#de5806] text-white rounded-xl shadow-lg hover:shadow-orange-600/20 transition-all duration-300 font-semibold text-sm flex items-center justify-center gap-2 disabled:opacity-50 disabled:hover:bg-gray-900 disabled:cursor-not-allowed transform active:scale-[0.99]">
      @if (isSubmitting) {
      <i class="fa-solid fa-spinner fa-spin text-base"></i>
      <span>{{ (paymentMethod === 'card' || paymentMethod === 'misr_card') ? ('bookingForm.redirectingPayment' |
        translate) : ('bookingForm.processingBooking' | translate) }}</span>
      } @else {
      <i class="fa-solid fa-check text-base"></i>
      <span>{{ 'bookingForm.confirmBooking' | translate }}</span>
      }
    </button>
  </form>
</div>